import React, { useEffect, useContext, useState } from "react";
import { Line } from "react-chartjs-2";
import { FileContext } from "../Dashboard";
import { useModal } from "../../contexts/ModalContext";

import Loading from "../Loading";

export default function Progress() {
  const { change, progressData } = useContext(FileContext);
  const [chartLoading, setChartLoading] = useState(true);
  const [chartData, setChartData] = useState("");
  const { modalDispatch } = useModal();

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          borderColor: "rgb(55, 55, 55)",
          tickColor: "rgb(55, 55, 55)",
        },

        ticks: {
          callback: function (value, index, values) {
            return value;
          },
          min: 0,
          max: 100,
          stepSize: 10,
        },
        title: {
          display: true,
          text: "Scores (in %)",
        },
        padding: 10,
      },
      x: {
        grid: {
          borderColor: "rgb(55, 55, 55)",
          tickColor: "rgb(55, 55, 55)",
        },

        title: {
          display: true,
          text: "Date",
        },
        ticks: {
          callback: function (val, index) {
            let date = new Date(parseInt(this.getLabelForValue(val)));
            let formattedDate = `${date.getMonth() + 1}/${date.getFullYear()}`;
            return formattedDate;
          },
        },
      },
    },
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
          },
          boxWidth: 20,
        },
        position: "bottom",
      },
    },
  };

  useEffect(() => {
    let labels = [];
    let disposition_effect = [];
    let overconfidence = [];
    let data = {};

    // console.log(progressData);
    // console.log(Object.keys(progressData));
    try {
      Object.keys(progressData).forEach((bias) => {
        Object.keys(progressData[bias]).forEach((timestamp) => {
          try {
            if (timestamp !== "overall") {
              //labels.push(parseInt(timestamp));
              labels.push(timestamp);
            }
          } catch (err) {
            modalDispatch({
              type: "SHOW_ERROR",
              payload: "Could not read bias dates of progress report, error: " + err,
            });
          }
        });
      });

      labels = [...new Set(labels)];
      labels.sort();
      // labels = labels.map((timestamp) => {
      //   let date = new Date(timestamp);
      //   let formattedDate = `${date.getMonth() + 1}/${date.getFullYear()}`;
      //   return formattedDate;
      // });
    } catch (err) {
      modalDispatch({
        type: "SHOW_ERROR",
        payload: "Could not read biases for progress report, error: " + err,
      });
    }

    Object.keys(progressData.disposition_effect).forEach((timestamp) => {
      if (timestamp !== "overall") {
        try {
          // let date = new Date(parseInt(timestamp));
          // let formattedDate = `${date.getMonth() + 1}/${date.getFullYear()}`;
          let score = progressData.disposition_effect[timestamp].disposition_effect * 100;
          let datapointObj = { x: timestamp, y: score };
          disposition_effect.push(datapointObj);
        } catch (err) {
          modalDispatch({
            type: "SHOW_ERROR",
            payload: "Could not read all disposition effect data, error: " + err,
          });
        }
      }
    });

    disposition_effect.sort(function (a, b) {
      let keyA = a.x,
        keyB = b.x;
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

    Object.keys(progressData.overconfidence).forEach((timestamp) => {
      if (timestamp !== "overall") {
        try {
          // let date = new Date(parseInt(timestamp));
          // let formattedDate = `${date.getMonth() + 1}/${date.getFullYear()}`;
          let score = progressData.overconfidence[timestamp].overconfidence * 100;
          let datapointObj = { x: timestamp, y: score };
          overconfidence.push(datapointObj);
        } catch (err) {
          modalDispatch({
            type: "SHOW_ERROR",
            payload: "Could not read all overconfidence data, error: " + err,
          });
        }
      }
    });

    overconfidence.sort(function (a, b) {
      let keyA = a.x,
        keyB = b.x;
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

    try {
      data = {
        labels: labels,
        datasets: [
          {
            label: "Disposition Effect",
            data: disposition_effect,
            //data: [20, 40, 55, 90, 60],
            fill: false,
            backgroundColor: "rgb(255, 99, 132)",
            borderColor: "rgba(255, 99, 132, 0.2)",
          },
          {
            label: "Overconfidence",
            data: overconfidence,
            //data: [40, 60, 40, 45, 80],
            fill: false,
            backgroundColor: "rgb(59, 93, 161)",
            borderColor: "rgba(59, 93, 161, 0.2)",
          },
        ],
      };
      setChartData(data);
      setChartLoading(false);
    } catch {
      setChartLoading(false);
    }
    // console.log(disposition_effect);
    // console.log(overconfidence);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [change]);

  return (
    <>
      {!chartLoading ? (
        <>
          <section className="progress-section">
            <div className="progress-container">
              <h1 className="report-header progress">
                <span> Progress</span>
              </h1>
              <figure className="progress-chart-container">
                <Line className="progress-chart" data={chartData} options={options} />
              </figure>
            </div>
          </section>
        </>
      ) : (
        <section className="progress-section" style={{ position: "relative", height: "500px" }}>
          <Loading inside={true} />
        </section>
      )}
    </>
  );
}
